import {B2BScreenParam, OrderVerifyStatus} from '@buncha/B2B/types';
import React, {useCallback, useEffect, useState} from 'react';

import BarcodeFooter from '../BarcodeFooter';
import BarcodeImage from '../BarcodeImage';
import BarcodeInfo from '../BarcodeInfo';
import BarcodeUserInfo from '../BarcodeUserInfo';
import {BarcodesOfOrders} from '@buncha/B2B/types/B2BBarcode';
import {Box} from '@buncha/components/core/view';
import {CustomFlatList} from '@buncha/components/core/list';
import {StyleSheet} from 'react-native';
import {b2bNav} from '@buncha/B2B/navigation';
import {useB2BBarcodesContext} from '@buncha/B2B/hooks/B2BBarcode';
import {useRoute} from '@react-navigation/native';

const BarcodeCheckoutList = () => {
  const {state} = useB2BBarcodesContext();
  const [barcodeToShow, setBarcodeToShow] = useState(state.listOfBarcodes[0]);
  const routeParams = useRoute()?.params as B2BScreenParam | undefined;
  const runId = routeParams?.runId;
  const isReScan = Boolean(routeParams?.orderLegacyIds?.length);
  const onPress = useCallback(
    (item: BarcodesOfOrders) => {
      const isBarcodeScanned = item.isBarcodeScanned;
      b2bNav.B2BOrderInfo({
        runId: runId,
        screenTitle: 'Order Info',
        status: isBarcodeScanned
          ? OrderVerifyStatus.scanSuccessful
          : OrderVerifyStatus.updationDone,
        orderId: item?.legacyOrderId,
      });
    },
    [runId],
  );
  const renderItem = useCallback(
    (item: {item: BarcodesOfOrders}) => {
      const itemData = item?.item;
      const buyerInfo = itemData?.buyerInfo;
      const buyerName = `${buyerInfo?.firstName} ${buyerInfo?.lastName}`;
      return (
        <Box>
          <BarcodeUserInfo userFullName={buyerName} />
          <Box style={styles.imageContainer}>
            <BarcodeImage barcodeUrl={itemData?.barcodeUrl} />
          </Box>
          <BarcodeInfo
            itemCount={itemData?.totalItemsCount}
            orderId={itemData?.legacyOrderId}
            scannedBarcode={state.barcodesScannedCount}
            totalBarcode={state.listOfBarcodes.length}
            onPress={() => onPress(itemData)}
            externalOrderId={itemData?.externalId}
          />
        </Box>
      );
    },
    [onPress, state.barcodesScannedCount, state.listOfBarcodes.length],
  );

  useEffect(() => {
    const barcodeToRender = state.listOfBarcodes.find(
      barcode => !barcode.isBarcodeScanned,
    );
    if (barcodeToRender) setBarcodeToShow(barcodeToRender);
  }, [state.listOfBarcodes]);

  return (
    <Box style={styles.flex}>
      <CustomFlatList
        showsVerticalScrollIndicator={false}
        renderItem={renderItem}
        data={[barcodeToShow]}
        scrollEnabled={false}
        extraData={barcodeToShow}
      />
      <Box style={[styles.flex, styles.footerStyle]}>
        <BarcodeFooter
          legacyId={barcodeToShow?.legacyOrderId}
          runId={runId ?? 0}
          isReScan={isReScan}
        />
      </Box>
    </Box>
  );
};

export default React.memo(BarcodeCheckoutList);

const styles = StyleSheet.create({
  imageContainer: {
    alignItems: 'center',
    marginBottom: 20,
    marginHorizontal: 20,
    padding: 5,
  },
  flex: {flex: 1},
  footerStyle: {
    justifyContent: 'flex-end',
  },
});
